import html2canvas from 'html2canvas';

export const makeCopyToClipboardHandler = (id: string) => () => {
  // Remove shadow-sm class from elements in non-operative metrics group and re-add it after copying
  // This is a workaround for the issue where html2canvas does not capture shadows and causes issues
  let childrenWithShadow: NodeListOf<HTMLElement> | null = null;
  if (id === 'non-operative-metrics-group') {
    childrenWithShadow = document.querySelectorAll(`#${id} .shadow-sm, #${id} * > .shadow-sm`);
    childrenWithShadow.forEach((el) => el.classList.remove('shadow-sm'));
  }

  html2canvas(document.getElementById(id) as HTMLCanvasElement).then((canvas) => {
    canvas.toBlob(async (blob) => {
      try {
        // Create a ClipboardItem and copy to clipboard
        if (!blob) {
          throw new Error('Failed to create image blob');
        }

        const item = new ClipboardItem({ 'image/png': Promise.resolve(blob) });
        await navigator.clipboard.write([item]);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Clipboard API error:', err);

        // Fallback method for browsers without Clipboard API support
      }
    }, 'image/png');
  });

  // Re-add shadow-sm class to elements in non-operative metrics group
  if (id === 'non-operative-metrics-group') {
    childrenWithShadow?.forEach((el) => el.classList.add('shadow-sm'));
  }
};
